import { fetchApi } from '@/config/axiosSetting.ts';
import { BackForCorrectionActionMutationDataType } from '@/modules/FileDetail/queries/sendActions/backForCorrectionAction/backForCorrectionActionMutationFn.types';

export const backForCorrectionActionMutationFn = (
  data: BackForCorrectionActionMutationDataType,
  id: string,
) => fetchApi.post(`actions/${id}/back_for_correction/`, data);
